import { render, staticRenderFns } from "./studentBooks.vue?vue&type=template&id=2849274a&"
import script from "./studentBooks.vue?vue&type=script&lang=js&"
export * from "./studentBooks.vue?vue&type=script&lang=js&"
import style0 from "./studentBooks.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports